import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonFunctionService } from '../../services/common-function.service';
import { ChartData, ChartOptions, ChartType, Chart, registerables, ChartEvent, Plugin } from 'chart.js';
import { ApiRequestsService } from '../../services/api-requests.service';
import zoomPlugin from 'chartjs-plugin-zoom';
import { DisableWhileDirective } from '../../shared/directives/disable-while.directive';
import 'chartjs-adapter-date-fns';
import { ToastrService } from 'ngx-toastr';


Chart.register(...registerables, zoomPlugin);
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, DisableWhileDirective],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit, AfterViewInit {
  @ViewChild('mainChartRef') mainChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('overviewChart') overviewChartRef!: ElementRef<HTMLCanvasElement>;
  mainChartInstance!: Chart | null;
  overviewChartInstance!: Chart | null;
  public barChartType: ChartType = 'line';
  data: any[] = [];
  overviewData: ChartData<'line'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Sales 2025', data: [65, 59, 80, 81, 56] }
    ]
  };
  isSubmitting: boolean = false;
  configs: any[] = [];
  selectedConfig: string = '';
  selectedConfigParams: string[] = [];
  selectedParam: string = '';
  fromDate: Date | null = null;
  toDate: Date | null = null;
  selectedStartX: number | null = null;
  timeWindowMs: number = 5 * 60 * 1000;
  chartPlugins: Plugin<'line'>[] = [this.rectangleHighlightPlugin()]

  public chartData: ChartData<'line'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Sales 2025', data: [65, 59, 80, 81, 56] }
    ]
  };

  overviewOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (event, elements, chart) => this.handleClick(event, chart),

    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'minute'
        }
      }
    },
    plugins: {
      // @ts-ignore
      highlightWindow: {}
    },

  };

  public barChartOptions: ChartOptions<'line'> =
    {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true
        },
        zoom: {
          pan: {
            enabled: true,
            mode: 'x', // or 'y' or 'xy'
            modifierKey: 'ctrl', // optional: only pan when holding ctrl
            onPan: ({ chart }) => {
              const xMin = chart.scales['x'].min;
              const xMax = chart.scales['x'].max;
              console.log('Panned to:', { xMin, xMax });
              this.selectedStartX = xMin;
              this.timeWindowMs = xMax - xMin;
              this.overviewChartInstance!.update();
            }
          },
          zoom: {
            wheel: {
              enabled: true
            },
            pinch: {
              enabled: true
            },
            mode: 'x', // or 'y' or 'xy'


            onZoom: ({ chart }) => {
              const xMin = chart.scales['x'].min;
              const xMax = chart.scales['x'].max;
              this.selectedStartX = xMin;
              this.timeWindowMs = xMax - xMin;
              this.overviewChartInstance!.update();
              console.log('Zoomed to:', { xMin, xMax });
            },
          },
          limits: {
            x: {
              min: new Date(this.fromDate!).getTime(),
              max: new Date(this.toDate!).getTime(),
            }
          },
        }
      },
      scales: {
        x: {
          type: 'time',
          time: {
            unit: 'minute', // or 'hour', 'day', etc.
            displayFormats: {
              minute: 'MMM d, HH:mm',
              hour: 'MMM d, HH:mm'
            },
            tooltipFormat: 'MMM d, yyyy HH:mm:ss'
          },
          title: {
            display: true,
            text: 'Timestamp'
          },
          min: 0,
          max: 0,
        },
        y: {
          title: {
            display: true,
            text: 'Value'
          }
        }
      }

    };

  showChart: boolean = false;
  constructor(public common: CommonFunctionService, private apiRequest: ApiRequestsService, private toaster: ToastrService) { }

  handleClick = (event: ChartEvent, chart: Chart) => {
    const xScale = chart.scales['x'];
    console.log(`Event on click`, event)
    const canvasPositionX = event.x;

    if (!canvasPositionX) {
      return;
    }
    const clickedTime = xScale.getValueForPixel(canvasPositionX) as number;
    console.log('clicked Time = ', clickedTime)

    this.selectedStartX = clickedTime;
    chart.update(); // Triggers re-draw

    let mainChart = this.mainChartInstance;
    if (mainChart) {
      console.log('I am here...')
      mainChart.options.scales!['x']!.min = this.selectedStartX;
      mainChart.options.scales!['x']!.max = this.selectedStartX + this.timeWindowMs;
      mainChart.update();
    }
    this.showChart = false;
    this.barChartOptions.scales!['x']!.min = this.selectedStartX;
    this.barChartOptions.scales!['x']!.max = this.selectedStartX + this.timeWindowMs;
    this.showChart = true;
  }

  rectangleHighlightPlugin() {
    return {
      id: 'highlightWindow',
      beforeDatasetsDraw: (chart: Chart) => {
        if (!this.selectedStartX) return;

        const ctx = chart.ctx;
        const xScale = chart.scales['x'];
        const yScale = chart.scales['y'];

        const startPixel = xScale.getPixelForValue(this.selectedStartX);
        const endPixel = xScale.getPixelForValue(this.selectedStartX + this.timeWindowMs);

        ctx.save();
        ctx.fillStyle = 'rgba(0, 123, 255, 0.2)';
        ctx.strokeStyle = 'rgba(0, 123, 255, 0.6)';
        ctx.lineWidth = 1;

        ctx.fillRect(
          startPixel,
          yScale.top,
          endPixel - startPixel,
          yScale.bottom - yScale.top
        );
        ctx.strokeRect(
          startPixel,
          yScale.top,
          endPixel - startPixel,
          yScale.bottom - yScale.top
        );

        ctx.restore();
      }
    };
  }

  ngAfterViewInit = () => {
    console.log('In ngAfterViewInit')
  }

  generateDateTimeLabels = (minTime: Date, maxTime: Date, intervalMinutes: number): string[] => {
    console.log('Min time = ', minTime);
    console.log('Max Time = ', maxTime)
    const labels: string[] = [];
    const current = new Date(minTime.getTime());

    while (current <= maxTime) {
      // const label = current.toISOString().slice(0, 16).replace('T', ' ');
      const label = current.toLocaleTimeString(); //.slice(0, 16).replace('T', ' ');
      labels.push(label);

      current.setMinutes(current.getMinutes() + intervalMinutes);
    }
    console.log('Labels ', labels)

    return labels;
  }

  getConfigurations = async () => {
    let { errorCode, errorDescription, Data } = await this.apiRequest.postAPICallWithPromise('messageconfig/getConfigurations', { requireParams: true })

    if (errorCode == this.apiRequest.NO_ERROR) {
      this.configs = [...[{ ctName: '' }], ...Data];
    }
  }

  selectedConfigChanged = (event: any) => {
    console.log('COnfig Changed = ', event);
    console.log(this.selectedConfig);
    let paramConfig = this.configs.find(c => c.ctName == this.selectedConfig);
    console.log('Params config = ', paramConfig)
    this.selectedConfigParams = [...[''], ...paramConfig['params']];
    console.log('Selected Config Params = ', this.selectedConfigParams);
  }

  getData = async () => {
    console.log('Submit Pressed...');
    this.isSubmitting = true;

    if (!this.selectedConfig || !this.selectedParam) {
      this.toaster.error(`Select the configuration and the configuration parameter to plot the graph.`);
      this.isSubmitting = false;
      return;
    }

    this.showChart = false;
    this.resetGraph();

    if (!this.selectedConfig) {
      this.isSubmitting = false;
      return;
    }
    let fromDate;
    let toDate;
    if (this.fromDate) {
      fromDate = new Date(this.fromDate).toISOString();
    }
    if (this.toDate) {
      toDate = new Date(this.toDate).toISOString();
    }
    console.log(`From date = ${this.fromDate}, to date = ${this.toDate}`)
    let { errorCode, errorDescription, Data } = await this.apiRequest.postAPICallWithPromise('sensordata/getSensorData', { config: this.selectedConfig, fromDate, toDate });
    if (errorCode == this.apiRequest.NO_ERROR) {
      this.data = Data['data'];

      if (!this.data.length) {
        // this.chartData = {
        //   datasets: [{
        //     data: []
        //   }]
        // };
        // this.overviewData = {
        //   datasets: [{
        //     data: []
        //   }]
        // }
        this.isSubmitting = false;
        return;
      }

      let startTime = new Date(this.data[0].timestamp);
      // let endTime = new Date(startTime.getTime() + 2 * 60 * 60 * 1000); // +2 hours
      let endTime = new Date(this.data[this.data.length - 1].timestamp); // +2 hours
      if (this.fromDate && this.toDate) {
        this.barChartOptions.scales!['x']!['min'] = fromDate;
        this.barChartOptions.scales!['x']!['max'] = toDate;
        this.overviewOptions.scales!['x']!['min'] = fromDate;
        this.overviewOptions.scales!['x']!['max'] = toDate;
        if (this.barChartOptions.plugins && this.barChartOptions.plugins.zoom) {
          this.barChartOptions.plugins.zoom.limits = {
            x: {
              min: new Date(this.fromDate).getTime(),
              max: new Date(this.toDate).getTime()
            }
          }

        }
      } else {
        this.barChartOptions.scales!['x']!['min'] = startTime.toISOString();
        this.barChartOptions.scales!['x']!['max'] = endTime.toISOString();
        this.overviewOptions.scales!['x']!['min'] = startTime.toISOString();;
        this.overviewOptions.scales!['x']!['max'] = endTime.toISOString();
        if (this.barChartOptions.plugins && this.barChartOptions.plugins.zoom) {
          this.barChartOptions.plugins.zoom.limits = {
            x: {
              min: new Date(startTime).getTime(),
              max: new Date(endTime).getTime()
            }
          }

        }
      }
      this.overviewData = {
        datasets: [{
          label: 'Full Timeline',
          data: this.data.map(d => ({ x: d.timestamp, y: d[this.selectedParam] })),
          borderColor: 'gray',
          pointRadius: 0
        }]
      };

      this.chartData = {
        datasets: [
          {
            data: this.data.map(d => ({ x: d.timestamp, y: d[this.selectedParam] })),
            label: this.selectedParam,
            fill: false,
            borderColor: 'blue',
            borderWidth: 1,
            tension: 0.3
          }
        ]
      };



      const ctx = this.mainChartRef.nativeElement.getContext('2d');
      if (ctx) {
        this.mainChartInstance = new Chart(ctx, {
          type: 'line',
          data: this.chartData,
          options: this.barChartOptions
        }
        );

      }



      const ctx1 = this.overviewChartRef.nativeElement.getContext('2d');
      if (ctx1) {
        this.overviewChartInstance = new Chart(ctx1, {
          type: 'line',
          data: this.overviewData,
          options: this.overviewOptions,
          plugins: this.chartPlugins
        }
        );

      }
      this.showChart = true;
    }
    this.isSubmitting = false;
  }

  resetGraph = () => {
    if (this.mainChartInstance) {
      this.mainChartInstance.destroy();
      this.mainChartInstance = null;
    }
    if (this.overviewChartInstance) {
      this.overviewChartInstance.destroy();
      this.overviewChartInstance = null;
    }



    this.chartData = {
      datasets: [{
        data: []
      }]
    };
    this.overviewData = {
      datasets: [{
        data: []
      }]
    }
  }

  resetCriteria = () => {
    this.isSubmitting = true;
    console.log(`Reset button is pressed....`);
    this.fromDate = null;
    this.toDate = null;
    this.selectedConfig = '';
    this.selectedConfigParams = [];
    this.selectedParam = '';
    this.resetGraph();
    this.isSubmitting = false;

  }

  ngOnInit(): void {

    this.getConfigurations();
    setTimeout(() => {
      // this.showChart = false;
      // const ctx = this.mainChartRef.nativeElement.getContext('2d');
      // if (ctx) {
      //   this.mainChartInstance = new Chart(ctx, {
      //     type: 'line',
      //     data: this.chartData,
      //     options: this.barChartOptions
      //   }
      //   );

      // }
    }, 300);
    this.common.pageTitle = 'Dashboard';

  }


}
